import _ from 'lodash'

export default function purgeObject(obj) {
  if (obj) {
    return _(obj).omitBy(_.isNil).omitBy(_.isEmpty).value()
  }
}
